module.exports = __webpack_public_path__ + "img/dashboard_active.4d2ea14c.svg";